import { render, staticRenderFns } from "./LearningHub.vue?vue&type=template&id=581b5913"
import script from "./LearningHub.vue?vue&type=script&lang=js"
export * from "./LearningHub.vue?vue&type=script&lang=js"
import style0 from "./LearningHub.vue?vue&type=style&index=0&id=581b5913&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports